import React, { useState } from 'react';
import { useForm } from 'react-final-form';
import { FFSelect } from '../select/select';
import { P, Button, Flex } from '@tpr/core';
import { ArrowRight } from '@tpr/icons';
import PostcodeFormatter from './postcodeFormatter';
import elementStyles from '../elements.module.scss';
import styles from './addressLookup.module.scss';
export var SelectAddress = function (_a) {
    var loading = _a.loading, testId = _a.testId, postcode = _a.postcode, addresses = _a.addresses, onChangePostcodeClick = _a.onChangePostcodeClick, onAddressSelected = _a.onAddressSelected, postcodeLookupLabel = _a.postcodeLookupLabel, changePostcodeButton = _a.changePostcodeButton, changePostcodeAriaLabel = _a.changePostcodeAriaLabel, selectAddressLabel = _a.selectAddressLabel, selectAddressPlaceholder = _a.selectAddressPlaceholder, selectAddressButton = _a.selectAddressButton, selectAddressRequiredMessage = _a.selectAddressRequiredMessage, noAddressesFoundMessage = _a.noAddressesFoundMessage, onValidatePostcode = _a.onValidatePostcode;
    function ensureNoUndefinedFields(addresses) {
        return addresses && addresses.length
            ? addresses.map(function (address) {
                return {
                    addressLine1: address.addressLine1 || '',
                    addressLine2: address.addressLine2 || '',
                    addressLine3: address.addressLine3 || '',
                    postTown: address.postTown || '',
                    county: address.county || '',
                    postcode: address.postcode || '',
                    nationId: address.nationId || null,
                    country: address.country || '',
                    countryId: address.countryId || null,
                    uprn: address.uprn || null,
                };
            })
            : [];
    }
    var addressesToTransform = ensureNoUndefinedFields(addresses);
    var options = addressesToTransform.map(function (address) {
        return {
            value: address,
            label: [
                address.addressLine1,
                address.addressLine2,
                address.addressLine3,
                address.postTown,
                address.county,
                address.postcode,
                address.country,
            ]
                .filter(function (x) { return (x ? true : false); })
                .join(', '),
        };
    });
    var form = useForm();
    var postcodeFormatter = new PostcodeFormatter();
    var _b = useState({
        touched: false,
        error: '',
    }), selectAddressValid = _b[0], setSelectAddressValid = _b[1];
    function getAddressIfValid() {
        var selectedAddressField = form.getFieldState('selectedAddress');
        if (selectAddressValid &&
            selectAddressValid.touched &&
            !selectAddressValid.error &&
            selectedAddressField &&
            selectedAddressField.value.value) {
            return selectedAddressField.value.value;
        }
    }
    function clearSelectedAddress() {
        var selectedAddressField = form.getFieldState('selectedAddress');
        if (selectedAddressField &&
            selectedAddressField.value &&
            selectedAddressField.value.value) {
            selectedAddressField.value.value = null;
        }
    }
    var updateAddressValidationIfChanged = function (updatedSelectAddressValid) {
        if (selectAddressValid.touched !== updatedSelectAddressValid.touched ||
            selectAddressValid.error !== updatedSelectAddressValid.error) {
            setSelectAddressValid(updatedSelectAddressValid);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { cfg: { alignItems: 'center' } },
            React.createElement(P, { className: styles.nonEditable + " " + styles.selectedPostcode },
                React.createElement("strong", { id: (testId ? testId + '-' : '') + 'postcode', className: elementStyles.labelText + " " + styles.nonEditableLabel }, postcodeLookupLabel),
                ' ',
                React.createElement("span", { "aria-labelledby": (testId ? testId + '-' : '') + 'postcode' }, postcodeFormatter.formatPostcode(postcode))),
            React.createElement(Button, { onClick: onChangePostcodeClick, testId: (testId ? testId + '-' : '') + 'change-postcode', className: styles.changePostcode, "aria-label": changePostcodeAriaLabel, disabled: loading, appearance: "secondary" }, changePostcodeButton)),
        React.createElement(FFSelect, { label: selectAddressLabel, name: "selectedAddress", options: options, inputWidth: 6, testId: (testId ? testId + '-' : '') + 'select-address-list', validate: function (value) {
                if (!selectAddressValid) {
                    updateAddressValidationIfChanged({ touched: false, error: '' });
                    return;
                }
                if (value && value.value) {
                    updateAddressValidationIfChanged({ touched: true, error: '' });
                }
            }, meta: selectAddressValid, notFoundMessage: noAddressesFoundMessage, placeholder: selectAddressPlaceholder, readOnly: true, disabled: loading, selectedItem: null }),
        React.createElement(Button, { disabled: loading || !getAddressIfValid(), testId: (testId ? testId + '-' : '') + 'select-address-button', appearance: "secondary", onClick: function () {
                var validAddress = getAddressIfValid();
                var isValidAddress = false;
                if (validAddress) {
                    isValidAddress = true;
                    onAddressSelected(validAddress);
                    clearSelectedAddress();
                }
                else {
                    updateAddressValidationIfChanged({
                        touched: true,
                        error: selectAddressRequiredMessage,
                    });
                }
                if (onValidatePostcode !== null) {
                    onValidatePostcode(isValidAddress);
                }
            }, className: styles.button + " " + styles.arrowButton },
            React.createElement(Flex, { cfg: {
                    alignItems: 'center',
                    pl: 4,
                    pr: 2,
                } },
                selectAddressButton,
                React.createElement(ArrowRight, { cfg: { fill: 'white' }, width: '32' })))));
};
//# sourceMappingURL=selectAddress.js.map